import { Suspense, lazy } from "react";
import { useRoutes } from "react-router-dom";
// layouts
// import MainLayout from '../layouts/main';
import MasterLayout from "src/layouts/MasterLayout";
// import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
// guards
import GuestGuard from "../guards/GuestGuard";
import AuthGuard from "../guards/AuthGuard";
// import RoleBasedGuard from "../guards/RoleBasedGuard";
// components
import LoadingScreen from "../components/LoadingScreen";
import Dashboard from "src/pages/dashboard/Dashboard";

import useStore from "src/contexts/AuthProvider";
import OrderDetail from "src/pages/dashboard/orderDetail";
import DisputedOrder from "src/pages/dashboard/DisputedOrder";
import FoodDisputedOrder from "src/pages/Food/FoodDisputedOrder";
import GroceryDisputedOrder from "src/pages/Grocery/GroceryDisputedOrder";
import CMSPages from "src/pages/dashboard/CMSPages";
import FAQ from "src/pages/dashboard/FAQ";
import MasterPassword from "src/pages/dashboard/MasterPassword";

import SubscriberList from "src/pages/dashboard/SubscriberList";
import UserFeedback from "src/pages/dashboard/UserFeedback";
//enum
// import { AdminRole, UserRole } from "src/utils/enum";

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  return (
    <Suspense
      fallback={
        <LoadingScreen
          sx={{
            ...{
              top: 0,
              left: 0,
              width: 1,
              zIndex: 9999,
              position: "fixed",
            },
          }}
        />
      }
    >
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  const permissionsData = useStore((state) => state.permissions);

  return useRoutes([
    {
      path: "login",
      element: (
        <GuestGuard>
          <Login />
        </GuestGuard>
      ),
    },
    {
      path: "dashboard",
      element: (
        <AuthGuard>
          <MasterLayout />
        </AuthGuard>
      ),
      children: [
        { index: true, element: <Dashboard /> },
        {
          path: "sub-admin",
          element:
            permissionsData?.SubAdmin?.substring(0, 1) == "1" ? (
              <AuthUsersList />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "users",
          element:
            permissionsData?.Users?.substring(0, 1) == "1" ? (
              <UsersList />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "delete-req-user",
          element:
            permissionsData?.DeleteRequestUserList?.substring(0, 1) == "1" ? (
              <DeleteRequestUsersList />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "delete-user",
          element:
            permissionsData?.DeleteUserList?.substring(0, 1) == "1" ? (
              <DeleteUsersList />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "roles",
          element:
            permissionsData?.Roles?.substring(0, 1) == "1" ? (
              <RolesPermissions />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "permission",
          element:
            permissionsData?.Permission?.substring(0, 1) == "1" ? (
              <Permission />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "food-sub-categories",
          element:
            permissionsData?.FoodSubCategories?.substring(0, 1) == "1" ? (
              <FoodCategory />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "food-order",
          element:
            permissionsData?.FoodOrderList?.substring(0, 1) == "1" ? (
              <FoodOrder />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "food-dish",
          element:
            permissionsData?.FoodDishList?.substring(0, 1) == "1" ? (
              <FoodDishList />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "grocery-list",
          element:
            permissionsData?.GroceryList?.substring(0, 1) == "1" ? (
              <GroceryList />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "grocery-order",
          element:
            permissionsData?.GroceryOrderList?.substring(0, 1) == "1" ? (
              <GroceryOrder />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "grocery-sub-categories",
          element:
            permissionsData?.GrocerySubCategories?.substring(0, 1) == "1" ? (
              <GroceryCategory />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "main-category",
          element:
            permissionsData?.MainCategory?.substring(0, 1) == "1" ? (
              <MainCategory />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "vendor",
          element:
            permissionsData?.Vendor?.substring(0, 1) == "1" ? (
              <Vendor />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "vendor/approved",
          element:
            permissionsData?.VendorList?.substring(0, 1) == "1" ? (
              <ApprovedVendor />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "vendor/pending",
          element:
            permissionsData?.PendingVendors?.substring(0, 1) == "1" ? (
              <PendingVendor />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "vendor/rejected",
          element:
            permissionsData?.RejectedVendors?.substring(0, 1) == "1" ? (
              <RejectedVendor />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "vendor/pending-kyc",
          element:
            permissionsData?.PendingKYC?.substring(0, 1) == "1" ? (
              <PendingKYC />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "vendor/approved-kyc",
          element:
            permissionsData?.ApprovedKYC?.substring(0, 1) == "1" ? (
              <ApprovedKYC />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "vendor/notUploadedKyc",
          element:
            permissionsData?.NotUploadedKYC?.substring(0, 1) == "1" ? (
              <NotUploadedKyc />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "vendor/pending-bank",
          element:
            permissionsData?.PendingBank?.substring(0, 1) == "1" ? (
              <PendingBank />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "vendor/change-bank",
          element:
            permissionsData?.ChangeBank?.substring(0, 1) == "1" ? (
              <ChangeBank />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "vendor/approved/view",
          element:
            permissionsData?.ApprovedVendors?.substring(0, 1) == "1" ? (
              <ApprovedVendorView />
            ) : (
              <Dashboard />
            ),
        },
        { path: "reg-user-edit", element: <UserEdit /> },
        { path: "getProfile", element: <MyProfile /> },
        { path: "changePassword", element: <ChangePassword /> },
        {
          path: "ngo/ngo-charity-item",
          element:
            permissionsData?.NGoCharityItems?.substring(0, 1) == "1" ? (
              <NGOCharityItemList />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "ngo/donation-transaction",
          element:
            permissionsData?.DonationTransaction?.substring(0, 1) == "1" ? (
              <NGODonationTransactionList />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "event/event-list",
          element:
            permissionsData?.EventList?.substring(0, 1) == "1" ? (
              <EventList />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "event/event-transaction",
          element:
            permissionsData?.EventTransaction?.substring(0, 1) == "1" ? (
              <EventTransactionList />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "payout/approved-payout",
          element:
            permissionsData?.ApprovedPayout?.substring(0, 1) == "1" ? (
              <ApprovedPayout />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "payout/pending-payout",
          element:
            permissionsData?.PendingPayout?.substring(0, 1) == "1" ? (
              <PendingPayout />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "payout/transaction",
          element:
            permissionsData?.ApprovedPayout?.substring(0, 1) == "1" ? (
              <PayoutTransactionHistory />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "payout-order-view",
          element:
            permissionsData?.ApprovedPayout?.substring(0, 1) == "1" ? (
              <PayoutOrderList />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "payout-event-view",
          element:
            permissionsData?.ApprovedPayout?.substring(0, 1) == "1" ? (
              <PayoutEventList />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "payout-charity-view",
          element:
            permissionsData?.ApprovedPayout?.substring(0, 1) == "1" ? (
              <PayoutDonationList />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "payout/transaction-list",
          element:
            permissionsData?.TransactionList?.substring(0, 1) == "1" ? (
              <TransactionList />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "app-version",
          element:
            permissionsData?.AppVersion?.substring(0, 1) == "1" ? (
              <AppVersion />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "coupon",
          element:
            permissionsData?.Coupon?.substring(0, 1) == "1" ? (
              <Coupon />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "notification",
          element:
            permissionsData?.Notification?.substring(0, 1) == "1" ? (
              <Notification />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "support-ticket",
          element:
            permissionsData?.SupportTicket?.substring(0, 1) == "1" ? (
              <SupportTicket />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "order-detail",
          element:
            permissionsData?.Users?.substring(0, 1) == "1" ? (
              <OrderDetail />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "disputed-order",
          element:
            permissionsData?.DisputedOrder?.substring(0, 1) == "1" ? (
              <DisputedOrder />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "food-disputed-order",
          element:
            permissionsData?.DisputedFoodOrder?.substring(0, 1) == "1" ? (
              <FoodDisputedOrder />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "grocery-disputed-order",
          element:
            permissionsData?.DisputedGroceryOrder?.substring(0, 1) == "1" ? (
              <GroceryDisputedOrder />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "admin-fees",
          element:
            permissionsData?.AdminFees?.substring(0, 1) == "1" ? (
              <Adminfees />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "cms-pages",
          element:
            permissionsData?.CMSPages?.substring(0, 1) == "1" ? (
              <CMSPages />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "FAQ",
          element:
            permissionsData?.FAQ?.substring(0, 1) == "1" ? <FAQ /> : <FAQ />,
        },
        {
          path: "master-password",
          element:
            permissionsData?.MasterPassword?.substring(0, 1) == "1" ? (
              <MasterPassword />
            ) : (
              <MasterPassword />
            ),
        },
        {
          path: "vendor/approved/view",
          element:
            permissionsData?.ApprovedVendors?.substring(0, 1) == "1" ? (
              <ApprovedVendorView />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "support-ticket/view",
          element:
            permissionsData?.SupportTicket?.substring(0, 1) == "1" ? (
              <SupportTicketView />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "support-ticket/edit",
          element:
            permissionsData?.SupportTicket?.substring(0, 1) == "1" ? (
              <SupportTicketEdit />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "support-subject",
          element:
            permissionsData?.SupportSubject?.substring(0, 1) == "1" ? (
              <SupportSubject />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "advertisement",
          element:
            permissionsData?.Advertisement?.substring(0, 1) == "1" ? (
              <Advertisement />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "subscriber",
          element:
            permissionsData?.SubscriberList?.substring(0, 1) == "1" ? (
              <SubscriberList />
            ) : (
              <Dashboard />
            ),
        },
        {
          path: "feedback",
          element:
            permissionsData?.Feedback?.substring(0, 1) == "1" ? (
              <UserFeedback />
            ) : (
              <Dashboard />
            ),
        },
      ],
    },
    {
      path: "/",
      element: (
        <AuthGuard>
          <MasterLayout />
        </AuthGuard>
      ),
      children: [{ index: true, element: <Dashboard /> }],
    },
    {
      path: "map",
      element: (
        <AuthGuard>
          <MasterLayout />
        </AuthGuard>
      ),
      children: [{ index: true, element: <Map /> }],
    },
  ]);
}

// IMPORT COMPONENTS
//Home
const Map = Loadable(lazy(() => import("../pages/home/Map")));

// Authentication
const Login = Loadable(lazy(() => import("../pages/authentication/Login")));

// Dashboard
// const ProfileSettings = Loadable(
//   lazy(() => import("../pages/dashboard/ProfileSettings"))
// );
const Permission = Loadable(
  lazy(() => import("../pages/dashboard/Permission"))
);
const AppVersion = Loadable(
  lazy(() => import("../pages/dashboard/AppVersion"))
);
const Coupon = Loadable(lazy(() => import("../pages/dashboard/Coupon")));
const Notification = Loadable(
  lazy(() => import("../pages/dashboard/Notification"))
);
const RolesPermissions = Loadable(
  lazy(() => import("../pages/dashboard/RolesPermissions"))
);
const UsersList = Loadable(lazy(() => import("../pages/dashboard/UsersList")));
const DeleteRequestUsersList = Loadable(
  lazy(() => import("../pages/dashboard/DeleteRequestUsersList"))
);
const DeleteUsersList = Loadable(
  lazy(() => import("../pages/dashboard/DeletedUsersList"))
);
const UserEdit = Loadable(lazy(() => import("../pages/dashboard/UserEdit")));
const MyProfile = Loadable(lazy(() => import("../pages/dashboard/MyProfile")));
const AuthUsersList = Loadable(
  lazy(() => import("../pages/dashboard/AdminList"))
);
const FoodCategory = Loadable(
  lazy(() => import("../pages/dashboard/FoodCategory"))
);
const MainCategory = Loadable(
  lazy(() => import("../pages/dashboard/MainCategory"))
);
const Vendor = Loadable(lazy(() => import("../pages/dashboard/Vendor")));
const ApprovedVendor = Loadable(
  lazy(() => import("../pages/dashboard/vendor/ApprovedVendor"))
);
const PendingVendor = Loadable(
  lazy(() => import("../pages/dashboard/vendor/PendingVendor"))
);
const PendingKYC = Loadable(
  lazy(() => import("../pages/dashboard/vendor/PendingKyc"))
);
const NotUploadedKyc = Loadable(
  lazy(() => import("../pages/dashboard/vendor/NotuploadKyc"))
);
const PendingBank = Loadable(
  lazy(() => import("../pages/dashboard/vendor/PendingBank"))
);
const ChangeBank = Loadable(
  lazy(() => import("../pages/dashboard/vendor/ChangeBank"))
);
const RejectedVendor = Loadable(
  lazy(() => import("../pages/dashboard/vendor/RejectedVendor"))
);
const ChangePassword = Loadable(
  lazy(() => import("../pages/dashboard/ChangePassword"))
);
const GroceryCategory = Loadable(
  lazy(() => import("../pages/dashboard/GroceryCategory"))
);
const NGOCharityItemList = Loadable(
  lazy(() => import("../pages/NGO/NGOCharityItem"))
);
const NGODonationTransactionList = Loadable(
  lazy(() => import("../pages/NGO/NGODonationTransactionList"))
);
const EventList = Loadable(lazy(() => import("../pages/Event/EventList")));
const EventTransactionList = Loadable(
  lazy(() => import("../pages/Event/EventTransactionList"))
);
// const ApprovedPayout = Loadable(lazy(() => import("../pages/payout/ApprovedPayout")))
const ApprovedPayout = Loadable(
  lazy(() => import("../pages/payout/ApprovedPayoutList"))
);
const PendingPayout = Loadable(
  lazy(() => import("../pages/payout/PendingPayoutList"))
);
const PayoutOrderList = Loadable(
  lazy(() => import("../pages/payout/PayoutOrderList"))
);
const PayoutEventList = Loadable(
  lazy(() => import("../pages/payout/PayoutEventList"))
);
const PayoutDonationList = Loadable(
  lazy(() => import("../pages/payout/PayoutDonationList"))
);
// const PendingPayout = Loadable(lazy(() => import("../pages/payout/PendingPayout")))
const TransactionList = Loadable(
  lazy(() => import("../pages/payout/TransactionList"))
);
const PayoutTransactionHistory = Loadable(
  lazy(() => import("../pages/payout/PayoutTransactionHistory"))
);
const FoodOrder = Loadable(lazy(() => import("../pages/Food/FoodOrderList")));
const GroceryOrder = Loadable(
  lazy(() => import("../pages/Grocery/GroceryOrderList"))
);
const SupportTicket = Loadable(
  lazy(() => import("../pages/dashboard/SupportTicket"))
);
const SupportTicketView = Loadable(
  lazy(() => import("../pages/SupportTicket/SupportTicketView"))
);
const SupportTicketEdit = Loadable(
  lazy(() => import("../pages/SupportTicket/SupportTicketEdit"))
);
const FoodDishList = Loadable(lazy(() => import("../pages/Food/FoodDishList")));
const GroceryList = Loadable(
  lazy(() => import("../pages/Grocery/GroceryList"))
);
const Adminfees = Loadable(lazy(() => import("../pages/dashboard/Adminfees")));
const ApprovedVendorView = Loadable(
  lazy(() => import("../pages/dashboard/vendor/ApprovedVendorView"))
);
const SupportSubject = Loadable(
  lazy(() => import("../pages/SupportTicket/SupportSubject"))
);
const Advertisement = Loadable(
  lazy(() => import("../pages/Advertisement/AdvertisementList"))
);
const ApprovedKYC = Loadable(
  lazy(() => import("../pages/dashboard/vendor/ApprovedKYC"))
);
// const PendingKYC = Loadable(lazy(()=>import("../pages/dashboard/vendor/PendingKYC")));
